import * as React from 'react'
import './icons.scss'

const InstagramIconSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="footer-icon" fill="none" {...props}>
    <g>
      <rect width={43.5} height={43.5} x={0.75} y={0.75} rx={11.25} />
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M28 10H16a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V16a6 6 0 0 0-6-6Z" />
        <path d="M26.946 21.267a5 5 0 1 1-9.89 1.467 5 5 0 0 1 9.89-1.467ZM28.995 16.427a.5.5 0 1 1-.99.146.5.5 0 0 1 .99-.146Z" />
      </g>
    </g>
  </svg>
)
export default InstagramIconSvg
